import { fetchData, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type AdminPayPutOrdersRequest = {
  limit?: number;
  page?: number;
  status?: string;
  min_sum?: number;
  max_sum?: number;
  order?: string;
  date_start?: number;
  trader_email?: string;
  merchant_email?: string;
  date_end?: number;
  bank?: string;
  method?: string;
  free?: boolean;
  order_id?: string;
  // dateStartTime: Date;
  // dateEndTime: Date;
};

export type AdminPayOutOrder = {
  id: string;
  invid: string;
  created_at: string;
  created_at_unix: number;
  method: string;
  requisite: string;
  bank: string;
  sum: number;
  sum_usdt: number;
  trader_email: string;
  merchant_email: string;
  closed_time: string | null;
  closed_time_unix: number | null;
  exchange_rate: number;
  status: string;
  trader_files: string[] | null;
  merchant_files: string[] | null;

  trader_ern_usdt: number;
  trader_ern_rub?: number;

  merchant_spend_rub: number;
  merchant_spend_usdt: number;

  trader_history?: AdminPayoutHistory[];

  assigned_to_trader_time?: string;
  assigned_to_trader_time_unix?: number;
};

export type AdminPayoutHistory = {
  trader: string;
  trader_ern_usdt: number;
  trader_commission: number;
  team_lead_commission_pay_out: number;
  team_lead_ern_usdt: number;
  team_lead: string;
  our_ern_usdt: number;
  our_commission: number;
  trader_email: string;
  merchant_spend_usdt: number;
  exchange_rate: number;
  sum_usdt: number;
  assigned_to_trader_time: string;
  assigned_to_trader_time_unix: number;
  cancelled_at?: string;
  cancel_comment?: string; // Optional, as it may not exist in all objects
  cancel_images?: string[]; // Optional, as it may not exist in all objects
};

export type AdminOrderResponse = PaginationResponse<{
  pay_out_orders: AdminPayOutOrder[];
}>;

export const getAdminPayOutOrdersApi = async (
  data?: AdminPayPutOrdersRequest
) => {
  try {
    const queryParams = getQueryParams(data);
    const response = await fetchData<AdminOrderResponse>({
      url: `api/v1/admin/pay-outs/order?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getAdminPayOutOrdersApi failed:", error);
    throw error;
  }
};

export const completePayOutOrderApi = async (orderId: string) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/completed-pay-out/order/${orderId}`,
      method: "PUT",
    });

    return response;
  } catch (error) {
    console.error("completePayOutOrderApi failed:", error);
    throw error;
  }
};

export const cancelPayOutOrderBySupportApi = async (
  orderId: string,
  remove_pool?: boolean
) => {
  try {
    const data = remove_pool ? { remove_pool: true } : undefined;
    const response = await fetchData<string>({
      url: `api/v1/admin/canceled-pay-out/order/${orderId}`,
      method: "PUT",
      data,
    });

    return response;
  } catch (error) {
    console.error("cancelPayOutOrderBySupportApi failed:", error);
    throw error;
  }
};
